import '../styles.scss'

type DateInputProps = {
  value: string | null
  disabled?: boolean
  onChange: (date: string | null) => void
}

export const DateInput = ({ value, disabled = false, onChange }: DateInputProps) => {
  return (
    <input
      type="date"
      className="date-input"
      disabled={disabled}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
    />
  )
}
